import React from 'react';
import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                mt: 8,
                py: 3,
                px: 2,
                backgroundColor: 'grey.900',
                color: 'grey.500',
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 1, sm: 3 }}
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    justifyContent="center"
                    divider={
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ borderColor: 'grey.800', display: { xs: 'none', sm: 'block' } }}
                        />
                    }
                >
                    <Link component={RouterLink} to="/roadmap" underline="hover" sx={{ color: 'grey.500', fontSize: '0.875rem' }}>
                        Roadmap
                    </Link>
                    <Link component={RouterLink} to="/contact" underline="hover" sx={{ color: 'grey.500', fontSize: '0.875rem' }}>
                        Contact
                    </Link>
                    <Link component={RouterLink} to="/terms" underline="hover" sx={{ color: 'grey.500', fontSize: '0.875rem' }}>
                        Terms
                    </Link>
                </Stack>
                <Typography variant="caption" color="grey.700" align="center" display="block" mt={2}>
                    © {new Date().getFullYear()} SovaVoice
                </Typography>
            </Container>
        </Box>
    );
}
